import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/admin/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

/** One-time exchange of #session_id → httpOnly cookie, then into the app. */
export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = /session_id=([^&]+)/.exec(location.hash || "");
    if (!m) { navigate("/login", { replace: true }); return; }
    authApi.exchange(decodeURIComponent(m[1]))
      .then((user) => { window.history.replaceState(null, "", window.location.pathname); navigate("/", { replace: true, state: { user } }); })
      .catch((e) => setError(e.response?.data?.detail || "Login failed"));
  }, []);
  return (
    <div className="min-h-screen bg-[#FFFFFF] text-gray-900 flex items-center justify-center font-mono text-sm" data-testid="auth-callback">
      {error ? <span className="text-[#FF3333]">{error} — <button className="underline" onClick={() => navigate("/login")}>back</button></span> : "Signing you in…"}
    </div>
  );
}

export function AdminLogin() {
  const [status, setStatus] = useState(null);
  useEffect(() => { authApi.status().then(setStatus).catch(() => setStatus({ enforced: false })); }, []);
  return (
    <div className="min-h-screen bg-[#FFFFFF] text-gray-900 flex items-center justify-center p-6" data-testid="admin-login">
      <div className="w-full max-w-sm border border-[#E4E4E0] rounded-sm p-8 bg-white text-center">
        <img src="/brand/offers4bricks-logo@1000.webp" alt="OFFERS4BRICKS" className="h-10 w-auto mx-auto" draggable={false} />
        <div className="font-mono text-[11px] text-gray-500 mt-1 uppercase tracking-wider">Admin console</div>
        <button onClick={startGoogleLogin} data-testid="google-login-btn"
          className="mt-8 w-full h-11 rounded-sm bg-white text-gray-900 font-bold text-sm hover:bg-zinc-200 flex items-center justify-center gap-2">
          <span className="font-black text-[#4285F4]">G</span> Sign in with Google
        </button>
        <p className="font-mono text-[10px] text-gray-500 mt-4">
          {status?.enforced ? `Restricted to ${status.admins} approved admin email${status.admins === 1 ? "" : "s"}.` : "Allowlist not set yet — add ADMIN_EMAILS in Settings → API Keys to lock this down."}
        </p>
      </div>
    </div>
  );
}

/** Wraps the whole BrickSource shell. null = checking · true = in · false = out. */
export function AuthGate({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [ok, setOk] = useState(location.state?.user ? true : null);
  useEffect(() => {
    if (ok === true) return;
    if (location.hash?.includes("session_id=")) return;
    authApi.me().then(() => setOk(true)).catch(async () => {
      // No session — only block if the allowlist is actually enforced.
      try { const s = await authApi.status(); if (!s.enforced) { setOk(true); return; } } catch {}
      setOk(false); navigate("/login", { replace: true });
    });
  }, []);
  if (ok === null) return <div className="min-h-screen bg-[#FFFFFF] text-gray-500 flex items-center justify-center font-mono text-xs" data-testid="auth-checking">Checking session…</div>;
  return ok ? children : null;
}
